import React, { Component } from 'react'
import {
	Link,
	withRouter,
} from 'react-router-dom'

//import { auth } from '../../../common/firebase'
import { PATH_NAMES } from '../../../common/constants'

// history enables us to redirect a user to another page
const Default = ({ history }) => {
	return (
		<React.Fragment>
			<div className="canvas">
				<div className="canvas__track">
					<div className="u-width-wrap">
						<div className="cta-container">
							<h1 className="page-title">Sign Up</h1>
							<SignUpForm history={history} />
							<p className="page-text">Already a member? <Link className="page-link" to="/login">Log In</Link></p>
						</div>
						<p className="copyright">&copy 2018 5FORTY</p>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}

const INITIAL_STATE = {
	email: '',
	error: null,
	passwordOne: '',
	passwordTwo: '',
	username: '',
}

const byPropKey = (propertyName, value) => () => ({
	[propertyName]: value,
})

class SignUpForm extends Component {
	constructor(props) {
		super(props)

		this.state = {
			...INITIAL_STATE
		}

		this.onSubmit = this.onSubmit.bind(this)
	}

	onSubmit(event) {
		event.preventDefault()
		// const {
		// 	email,
		// 	passwordOne,
		// } = this.state

		// used to redirect on successful account creation
		const {
			history,
		} = this.props
		
		history.push(PATH_NAMES.BROWSE)

		return

		/*
		auth.doCreateUserWithEmailAndPassword(email, passwordOne)
			.then((authUser) => {
				this.setState(() => {
					// if the request resolves successfully, you can set the local state
					// of the component to its initial state to empty the input fields
					return ({
						...INITIAL_STATE
					})
				})

				// redirect to browse on successful account creation
				history.push(PATH_NAMES.BROWSE)
			})
			.catch((error) => {
				this.setState(byPropKey('error', error))
			})

		// prevents a reload of the browser which otherwise would be
		// a natural behavior when using a submit in a form
		event.preventDefault()
		*/
	}

	render() {
		const {
			email,
			error,
			passwordOne,
			//passwordTwo,
			//username,
		} = this.state

		//const isInvalid = passwordOne === '' || email === ''

		return (
			<form className="form" onSubmit={this.onSubmit}>
				<label className="form-ui form-ui-txt" htmlFor="email">
					<span className="form-ui-txt__label">Email</span>
					<input
						id="email"
						className="form-ui-txt__input"
						type="email"
						name="email"
						autoComplete="true"
						placeholder="Email"
						value={email}
						onChange={event => this.setState(byPropKey('email', event.target.value))}
					/>
					<div className="form-ui-txt__error">
						<div className="form-ui-txt__message-wrapper">
							<span className="form-ui-txt__message">Please enter a valid email.</span>
						</div>
					</div>
				</label>
				<label className="form-ui form-ui-txt" htmlFor="password">
					<span className="form-ui-txt__label">Password</span>
					<input
						id="password"
						className="form-ui-txt__input"
						type="password"
						name="password"
						autoComplete="true"
						placeholder="Create a password"
						value={passwordOne}
						onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
					/>
					<div className="form-ui-txt__error">
						<div className="form-ui-txt__message-wrapper">
							<span className="form-ui-txt__message">Please create a password.</span>
						</div>
					</div>
				</label>
				<div className="form-ui form-ui-btn form-ui-btn--primary-color">
					<input id="submit" className="form-ui-btn__input" disabled={false} type="submit" name="submit" value="Sign Up" />
				</div>
				{ error && <p style={{ color: '#f00' }}>{error.message}</p> }
			</form>
		)
	}
}

// higher order component to make the router properties accessible
// in the props of a component

// withRouter() higher order component gets access to all
// the properties of the router. Thus when passing the SignUpPage
// component to the withRouter() higher order component, it has in
// its own function signature access to the props of the React Router
export default withRouter(Default)



// WEBPACK FOOTER //
// ./src/mobile/pages/signup/index.js